export default __webpack_public_path__ + "static/media/face_smile_yellow.98a530a0.svg";